(function () {
  function initHotspotSection(section) {
    var hotspots = section.querySelectorAll('.js-product-hotspot');

    function closeHotspot(hotspot, focusToggle) {
      var toggle = hotspot.querySelector('.js-product-hotspot-toggle');
      if (!hotspot.classList.contains('is-active')) return;
      hotspot.classList.remove('is-active');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        if (focusToggle) toggle.focus();
      }
    }

    function closeAll(except, focusToggle) {
      hotspots.forEach(function (hotspot) {
        if (hotspot === except) return;
        closeHotspot(hotspot, focusToggle);
      });
    }

    hotspots.forEach(function (hotspot) {
      var toggle = hotspot.querySelector('.js-product-hotspot-toggle');
      var close = hotspot.querySelector('.js-product-hotspot-close');

      if (toggle) {
        toggle.addEventListener('click', function (event) {
          event.stopPropagation();
          var isActive = hotspot.classList.contains('is-active');
          closeAll(hotspot, false);
          hotspot.classList.toggle('is-active', !isActive);
          toggle.setAttribute('aria-expanded', String(!isActive));
        });
      }

      if (close) {
        close.addEventListener('click', function (event) {
          event.stopPropagation();
          closeHotspot(hotspot, true);
        });
      }
    });

    document.addEventListener('click', function (event) {
      hotspots.forEach(function (hotspot) {
        if (hotspot.contains(event.target)) return;
        closeHotspot(hotspot, false);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      closeAll(null, true);
    });
  }

  document.querySelectorAll('.c-product-hotspots').forEach(initHotspotSection);
})();
